import { Loader2 } from 'lucide-react';
import type { CsvFieldMapping } from '@/utils/csvAiMapping';

interface AnalyzingStepProps {
  aiMapping: CsvFieldMapping | null;
}

export function AnalyzingStep({ aiMapping }: AnalyzingStepProps) {
  const isUploading = aiMapping !== null;

  return (
    <div className="flex flex-col items-center justify-center py-16 px-8">
      <Loader2 className="w-12 h-12 text-blue-600 animate-spin mb-6" />
      <h3 className="text-lg font-semibold text-gray-900 mb-2">
        {isUploading ? 'Uploading your data' : 'Analyzing your data'}
      </h3>
      <p className="text-sm text-gray-600 text-center max-w-md">
        {isUploading
          ? 'Saving contacts to the backend...'
          : 'Detecting field types and mapping columns...'}
      </p>
    </div>
  );
}
